export const ellipsis = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const cellContentStyle = {
  display: '-webkit-box',
  WebkitLineClamp: '5',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-all',
  whiteSpace: 'normal',
};
export const dotStyle = (color: string | any | ((args: any) => string | undefined), size = 10) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  background: color,
});
export const refetchingStyle = {
  filter: 'blur(3px) grayscale(1)',
  opacity: 0.5,
  pointerEvents: 'none',
  userSelect: 'none',
};
